module.exports = __webpack_public_path__ + "greenyogamat.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/greenyogamat.png
// module id = 881
// module chunks = 0